// extracted by mini-css-extract-plugin
module.exports = {"chip":"chip_chip__3YzPZ","chip_icon":"chip_chip_icon__1zadM"};